import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

interface getAgpmTaskHistoryDataTableStructureProps {
  translate?: (key: string) => string;
}
export const getAgpmTaskHistoryDataTableStructure = ({
  translate = (key: string) => key,
}: getAgpmTaskHistoryDataTableStructureProps): DynamicDataTable => {
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.task_history.table.name',
    accessorKey: 'name',
    variant: DataTableColumnVariant.TEXT,
  };
  const assigneeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.task_history.table.assignee',
    accessorKey: 'assignee',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (value)
        return {
          value,
        };
      return {
        value: translate('agpm.task_history.table.no_assignee'),
        class: 'opacity-70',
      };
    },
  };

  const startDateColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.task_history.table.start_date',
    accessorKey: 'startDate',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const endDateColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.task_history.table.end_date',
    accessorKey: 'endDate',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const observationColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.task_history.table.observation',
    accessorKey: 'observation',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (value)
        return {
          value,
        };
      return {
        value: 'agpm.task_history.table.no_observation',
        class: 'opacity-70',
      };
    },
    class: 'w-[10vw] min-w-0',
  };

  const concernColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.task_history.table.concern',
    accessorKey: 'concern',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (value)
        return {
          value,
        };
      return {
        value: 'agpm.task_history.table.no_concern',
        class: 'opacity-70',
      };
    },
    class: 'w-[10vw] min-w-0',
  };

  return {
    singular: 'Historique des Tâches des Avis de Marchés Publics',
    plural: 'Historiques des Tâches des Avis de Marchés Publics',
    columns: [nameColumn, startDateColumn, endDateColumn, concernColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    rowRenderOverride: row => {
      return {
        class: row.current ? 'bg-green-100 dark:bg-green-900' : '',
      };
    },
  };
};
